(function (window, undefined) {

    var Carousel = function (ele, obj) {

        this.ele = ele;//ul容器
        this.swiperBtn = obj.swiperBtn; //下面按钮
        this.cardsList = this.ele.children();//卡片
        this.showNum = obj.showNum || 5; // 显示个数
        this.cardsNum = this.cardsList.length;//卡片数量 

        this.direction = obj.direction ? obj.direction : 'horizontal';//方向判断
        this.scale = obj.scale;//比例
        this.transition = obj.transition || '500ms';//过渡
        this.transformOrigin = obj.transformOrigin;//变形原点
        this.opacity = obj.opacity;//透明度
        this.offsetDistance = obj.offsetDistance;//间距偏移值

        this.switchBtn = obj.switchBtn;//切换按钮
        this.isClickCard = obj.isClickCard || false;//是否点击卡片切换
        this.isAuto = obj.isAuto || false;//是否自动轮播
        this.interval = obj.interval || 5000;

        this.n = 0;
        this.mediant = Math.floor(this.cardsNum / 2);//中间数
        this.cardsListArr = [].slice.call(this.cardsList);//将卡片对象存到数组中
        this.timer = null;//定时器
        this.cssObj = {};//样式存储对象

        this.certainStyle();
        this.switchEffect();
        this.cardsClick();
        this.switchBtnClick();
        this.autoMove();
        this.switchTimer();
        // 下方按钮的切换功能
        this.swiperDot();
        // 监听屏幕尺寸
        this.resizeEvent();
        // 左右滑动事件的注册
        // this.slideEvent();

    };

    Carousel.prototype = {

        constructor: Carousel,

        switchTimer: function () {
            var carousel = this;
            if (this.isAuto) {
                this.cardsList.on('mouseover', function () {
                    clearInterval(carousel.timer);
                });
                this.cardsList.on('mouseout', function () {
                    carousel.autoMove();
                });
            };
        },

        //确定的样式
        certainStyle: function () {
            this.cssObj.position = 'absolute';
            if (this.scale) {
                this.scale.length == 1 && this.scale.push(this.scale[0]);
            };
            if(this.direction == 'horizontal'){
                this.cssObj.left = '50%';
                this.availSize = this.ele.outerWidth();
                this.cardSize = this.cardsList.eq(0).outerWidth();
            }else if(this.direction == 'vertical'){
                this.cssObj.top = '50%';
                this.availSize = this.ele.outerHeight();
                this.cardSize = this.cardsList.eq(0).outerHeight();
            };
            this.offsetDistance = this.offsetDistance || this.availSize / (this.cardsNum - 1);
            this.transformOrigin && (this.cssObj.transformOrigin = this.transformOrigin);
            this.cssObj.transition = this.transition;
        },

        //动态样式
        dynamicStyle: function (offsetIndex, offsetIndexAbs, reset) {
            //根据方向确定margin的left或者top值
            if(this.direction == 'horizontal'){
                this.cssObj.marginLeft = - this.cardSize / 2 + this.offsetDistance * offsetIndex + 'px';
            }else if(this.direction == 'vertical'){
                this.cssObj.marginTop = - this.cardSize / 2 + this.offsetDistance * offsetIndex + 'px';
            };
            //设置z-index
            this.cssObj.zIndex = reset;
            //设置透明度
            this.opacity && (this.cssObj.opacity = Math.pow(this.opacity, offsetIndexAbs));
            //设置显示个数
            if (offsetIndexAbs * 2 - this.showNum > 0 ) {
                this.cssObj.opacity = 0;
            }
            // 
            //设置缩放比例
            this.scale && (this.cssObj.transform = 'scale(' + Math.pow(this.scale[0], offsetIndexAbs) + ',' + Math.pow(this.scale[1], offsetIndexAbs) + ')');
        },

        switchEffect: function () {
            var carousel = this;
            var offsetNum = Math.abs(carousel.n - carousel.mediant);
            if (carousel.n == carousel.mediant) {
                return;
            } else if (carousel.n > carousel.mediant) {
                carousel.cardsListArr = carousel.cardsListArr.concat(carousel.cardsListArr.splice(0, offsetNum));
            } else {
                carousel.cardsListArr = carousel.cardsListArr.splice(carousel.cardsNum - offsetNum).concat(carousel.cardsListArr);
            };
            $(carousel.cardsListArr).each(function (i, e) {
                var offsetIndex = i - carousel.mediant,
                    offsetIndexAbs = Math.abs(offsetIndex),
                    reset = carousel.mediant - offsetIndexAbs;
                //设置动态样式
                carousel.dynamicStyle(offsetIndex, offsetIndexAbs, reset);
                $(e).css(carousel.cssObj);
                $(e).attr('n', i);
                // 设置激活的样式
                if (i === carousel.mediant) {
                    $(e).children('.img').children('.subCtx').css('visibility', 'visible')
                } else {
                    $(e).children('.img').children('.subCtx').css('visibility', 'hidden');
                }
                
            });
        },

        cardsClick: function () {
            if (this.isClickCard) {
                var carousel = this;
                $(carousel.cardsListArr).on('click', function () {
                    if (parseInt($(this).attr('n')) === carousel.mediant) {
                        let location = $(this).attr('path')
                        window.open(`${window.location.origin}${location}`,"_blank")
                    }
                    carousel.n = $(this).attr('n');
                    carousel.switchEffect();
                    
                });
            };
        },
        swiperDot: function() {
            var carousel = this;
            for (let i = 0; i < carousel.cardsNum; i++) {
                carousel.swiperBtn.eq(i).on('mouseover', function () {
                    carousel.n = $(`#cardsNo${i}`).attr('n')
                    carousel.switchEffect();
                })
            }
        },
        prev: function () {
            var carousel = this;
            carousel.n = carousel.mediant - 1;
            carousel.n < 0 && (carousel.n = carousel.cardsNum - 1);
            carousel.switchEffect();
        },

        next: function () {
            var carousel = this;
            carousel.n = carousel.mediant + 1;
            carousel.n > carousel.cardsNum - 1 && (carousel.n = 0);
            carousel.switchEffect();
        },

        switchBtnClick: function () {
            var carousel = this;
            if (carousel.switchBtn) {
                carousel.switchBtn.eq(0).on('click', function () {
                    carousel.prev();
                    if (carousel.isAuto) {
                        clearInterval(carousel.timer);
                        carousel.cardsList.eq(carousel.n).one('transitionend', function () {
                            carousel.autoMove();
                        });
                    };
                });
                carousel.switchBtn.eq(1).on('click', function () {
                    carousel.next();
                    if (carousel.isAuto) {
                        clearInterval(carousel.timer);
                        carousel.cardsList.eq(carousel.n).one('transitionend', function () {
                            carousel.autoMove();
                        });
                    };
                });
            };
        },

        autoMove: function () {
            var carousel = this;
            if (carousel.isAuto) {
                clearInterval(carousel.timer);
                carousel.timer = setInterval(function () {
                    carousel.next();
                }, carousel.interval);
            };

        },
        resizeEvent: function() {
            window.οnresize=function() { 
                let tempWidth = $(window).width();
                if (tempWidth < 769) {
                    this.showNum = 3
                }  
            } 
        },
        slideEvent: function () {
            let threshold =150
            let dragStart = 0
            let dragEnd = 0
            var carousel = this;
            function dragPos() {
                return dragEnd - dragStart;
            }
            if (this.isWechart()) {
                $('#container').on('ontouchstart', function(event){
                    dragStart = event.pageX;
                    // $(this).on('mousemove', function(event){
                    //     console.log('dragEnd' + dragEnd)
                    //     dragEnd = event.pageX;
                    //     $(this).css('transform','translateX('+ dragPos() +'px)')
                    // })
                })
                $('#container').on('ontouchend', function(event){
                    dragEnd = event.pageX;
                    // console.log(dragPos())
                    if (dragPos() > 0) {
                        setTimeout(() => {
                            carousel.prev()
                        }, 1)
                        
                    } else {
                        setTimeout(() => {
                            carousel.next()
                        }, 1)
                    }
                })
            } else {
                $('#container').on('mousedown', function(event){
                    dragStart = event.pageX;
                    // $(this).on('mousemove', function(event){
                    //     console.log('dragEnd' + dragEnd)
                    //     dragEnd = event.pageX;
                    //     $(this).css('transform','translateX('+ dragPos() +'px)')
                    // })
                })
                $('#container').on('mouseup', function(event){
                    dragEnd = event.pageX;
                    // console.log(dragPos())
                    if (dragPos() > 0) {
                        setTimeout(() => {
                            carousel.prev()
                        }, 1)
                        
                    } else {
                        setTimeout(() => {
                            carousel.next()
                        }, 1)
                    }
                })
            }
        },
        // 判断是否为wechat类型
        isWechart: function() {
            var rst = true
            if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
                var ua = navigator.userAgent.toLowerCase();
                if (!(ua.match(/MicroMessenger/i) == "micromessenger")) {
                    rst = false;
                }
            }else {
                rst = false;
            }
            return rst;
        }
    };

    window.Carousel = Carousel;

}(window));


// WEBPACK FOOTER //
// ./src/common/js/carousel.js